import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";

import "moment-timezone";

import {
    setLoading as setPackagesLoading,
    setPackages,
    setError,
} from "../../features/common/packageSlice";
import { deletePackageById, packageList } from "../../services/userservice";

const PackageList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const { packages, loading, error } = useSelector((state) => state?.package);
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [deleteUser, setDeleteUser] = useState("")
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchPackageData = async () => {
            try {
                dispatch(setPackagesLoading());
                const response = await packageList();
                dispatch(setPackages(response));
            } catch (error) {
                dispatch(setError(error.message));
            }
        };
        fetchPackageData();
    }, [dispatch, deleteUser]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Filter packages based on search term
    const filteredPackages = packages.filter(
        (pkg) =>
            pkg?.package_id?.includes(searchTerm) ||
            pkg?.package_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pkg?.package_country?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pkg?.package_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pkg?.package_category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pkg?.status?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;



    const handleDelete = async () => {
        try {
            const deleteResponse = await deletePackageById(selectedUserId);
            if (deleteResponse.status === 200 || deleteResponse.status === 201) {
                setDeleteUser(selectedUserId);
                closeModal();
            } else {
                setError(deleteResponse.message || "Failed to delete user");
            }
        } catch (error) {
            alert("You are not authorized to delete this user");
        }
    };



    const openModal = (userId) => {
        setSelectedUserId(userId);
        setShowModal(true);
    };


    const closeModal = () => {
        setShowModal(false);
    };


    const confirmDelete = async () => {
        await handleDelete(selectedUserId);
        closeModal();
    };

    // Table rows to show per page Start

    const indexOfLastPackage = currentPage * rowsPerPage;
    const indexOfFirstPackage = indexOfLastPackage - rowsPerPage;
    const currentPackages = filteredPackages.slice(indexOfFirstPackage, indexOfLastPackage);

    // bottom pagination start

    const totalPages = Math.ceil(filteredPackages.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first 3 pages
            pages.push(1, 2, 3);

            // Show "..." if currentPage is beyond 5
            if (currentPage > 5) {
                pages.push("...");
            }

            // Show current page and neighbors
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);

            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) pages.push(i);
            }

            // Show "..." if currentPage is far from end
            if (currentPage < totalPages - 4) {
                pages.push("...");
            }

            // Always show last 3 pages
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Packages</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Packages</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <Link to="/add-tour-and-packages" className="btn btn-primary mb-md-0 mb-2 py-1 mr-3">
                                            <i className="fas fa-plus" /> Add Packages
                                        </Link>
                                        <div className="card-tools">
                                            <div
                                                className="input-group input-group-sm"
                                                style={{ width: "250px" }}
                                            >
                                                <input
                                                    type="text"
                                                    name="table_search"
                                                    className="form-control float-right"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Package ID</th>
                                                    <th>Package Name</th>
                                                    <th>Package Type</th>
                                                    <th>Package Country</th>
                                                    <th>Destination</th>
                                                    <th>Package Category</th>
                                                    <th>Status</th>
                                                    <th style={{ width: "15%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            {currentPackages.length > 0 ? (
                                                <tbody>
                                                    {currentPackages.map((pkg) => (
                                                        <tr key={pkg.package_id}>
                                                            <td>{pkg.package_id}</td>
                                                            <td>{pkg.package_name}</td>
                                                            <td>{pkg.package_type}</td>
                                                            <td>{pkg.package_country}</td>
                                                            <td>{pkg.package_destination}</td>
                                                            <td>
                                                                {pkg.package_categories && pkg?.package_categories?.length > 0 ? (
                                                                    <ul>
                                                                        {pkg?.package_categories?.map((category) => (
                                                                            <li key={category.id}>{category?.name}</li>
                                                                        ))}
                                                                    </ul>
                                                                ) : (
                                                                    <span>No Categories</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className={`badge p-2 w-100 ${pkg?.status === "active"
                                                                        ? "badge-success"
                                                                        : "badge-danger"
                                                                        }`}
                                                                >
                                                                    {pkg?.status?.toUpperCase()}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    <Link to={`/edit-package/${pkg.id}`}>
                                                                        <button className="btn btn-primary btn-sm">
                                                                            Edit
                                                                        </button>
                                                                    </Link>

                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => openModal(pkg?.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No Packages found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstPackage + 1} to {Math.min(indexOfLastPackage, filteredPackages.length)} of {filteredPackages.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete this Package?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>


    );
};

export default PackageList;
